import { AfterViewInit, Component, OnInit } from '@angular/core';
import { OptionEngine } from '../../engine/option.engine';
import { Utilities } from '../../helpers/utilities';
import { Globals } from '../../services/globals';


@Component({
  selector: 'custom-features-addendum',
  templateUrl: './custom-features-addendum.component.html',
  styleUrls: ['./custom-features-addendum.component.css']
})

export class CustomFeaturesAddendumComponent implements OnInit, AfterViewInit {
  utilities: Utilities = new Utilities();

  constructor(public globals: Globals) { }

  engine: OptionEngine;

  ngOnInit(): void {
    this.engine = this.globals.validateSession(false, true);
  }
  get subTotal(): number {
    return this.engine.selectedOptions.reduce((acc, obj) => acc + (obj.price * obj.quantity), 0);
  }
  ngAfterViewInit() { }
}
